import { LocaleUtil } from '@xengage/gw-portals-util-js';

export default {
    // Platform LocaleUtil functions
    sortProperties: LocaleUtil.sortProperties
};
